var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/pages/status-page.tsx";
import React from 'react';
import LinkFooter from 'soapbox/features/ui/components/link-footer';
import { WhoToFollowPanel, TrendsPanel, SignUpPanel, CtaBanner } from 'soapbox/features/ui/util/async-components';
import { useAppSelector, useFeatures } from 'soapbox/hooks';
import { Layout } from '../components/ui';
import BundleContainer from '../features/ui/containers/bundle-container';

const StatusPage = _ref => {
  let {
    children
  } = _ref;
  const me = useAppSelector(state => state.me);
  const features = useFeatures();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, children, !me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: CtaBanner,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "cta-banner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 27
    }
  }))), /*#__PURE__*/React.createElement(Layout.Aside, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 7
    }
  }, !me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: SignUpPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "sign-up-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 27
    }
  })), features.trends && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: TrendsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 5,
    key: "trends-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 27
    }
  })), me && features.suggestions && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: WhoToFollowPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 3,
    key: "wtf-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement(LinkFooter, {
    key: "link-footer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  })));
};

export default StatusPage;